import { Component, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-nav-link',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './nav-link.component.html',
})
export class NavLinkComponent {
  readonly path = input.required<string>();
  readonly label = input.required<string>();
  readonly icon = input.required<string>();
  readonly ariaLabel = input.required<string>();
  readonly exact = input(false);
  readonly mobile = input(false);

  readonly activated = output<void>();
}
